module.exports = __webpack_public_path__ + "static/media/attach_file_mobile.da51d2c7.svg";